import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home/home.component';
import { TenantListComponent } from './core/components/tenants/tenant-list/tenant-list.component';
import { ApiWelcomeComponent } from './core/api-docs/api-welcome/api-welcome.component';
import { environment } from 'src/environments/environment';
import { ObjectFormComponent } from './core/components/pages/object-form/object-form.component';
import { FormsModule } from '@angular/forms';
import { ModuleListComponent } from './core/components/pages/module-list/module-list.component';
import { SystemComponent } from './core/components/pages/system/system.component';
import { SystemStatusComponent } from './core/components/pages/system-status/system-status.component';
import { CreateComponent } from './core/components/tenants/create/create.component';
import { DashboardComponent } from './core/components/pages/dashboard/dashboard.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { ObjectSearchComponent } from './core/components/data/object-search/object-search.component';
import { ImportFileComponent } from './core/components/tenants/importFile/import-file';
import { SignupComponent } from './core/components/signup/signup.component';
import { ModelStatusComponent } from './core/components/pages/model-status/model-status.component';
import { NotificationComponent } from './core/components/notification/notification.component';
import { ProfileMenuComponent } from './core/components/profile-menu/profile-menu.component';
import { DocumentPreviewComponent } from './core/components/pages/dashboard/document-preview/document-preview.component';
import { ObjectAccessComponent } from './core/components/pages/object-access/object-access.component';
import { GlobalErrorHandler } from './core/services/global-error-handler';


@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        TenantListComponent,
        ApiWelcomeComponent,
        ObjectFormComponent,
        ModuleListComponent,
        SystemComponent,
        SystemStatusComponent,
        ModelStatusComponent,
        CreateComponent,
        DashboardComponent,
        SafeHtmlPipe,
        TranslatePipe,
        ObjectSearchComponent,
        ImportFileComponent,
        SignupComponent,
        NotificationComponent,
        ProfileMenuComponent,
        DocumentPreviewComponent,
        ObjectAccessComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgxExtendedPdfViewerModule,
        AuthModule.forRoot({
            domain: environment.authDomain,
            clientId: environment.authClientId,
            authorizationParams: {
                audience: environment.authAudience,
                redirect_uri: window.location.origin,
            },
            httpInterceptor: {
                allowedList: [
                    environment.apiUrl + '/*'
                ]
            }
        })],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
